import { useAtomValue } from 'jotai';
import { LineChartData } from '../../../types';
import { selectedViewDatePFJ } from '../state/PageStateJ';
import { IMetricsDataModel } from '../../../data-models/metrics.data-model';
import { earliestOf, isValidDate, plainDateToZonedDateTime } from '../../../util/date-utilts';
import { QuartersBuilder } from '../services/QuartersBuilder';
import { cumulativeQuarterSeries } from '../services/cumulativeQuarterSeries';

export const useInvestmentAmountOverTime = (filteredData: IMetricsDataModel[]): LineChartData[] => {
  const date = useAtomValue(selectedViewDatePFJ);

  return computeInvestmentAmountOverTime(date || new Date(), filteredData);
};

export function computeInvestmentAmountOverTime(date: Date, filteredData: IMetricsDataModel[]) {
  const transactions = (filteredData ?? [])
    .flatMap(({ transactions: rows }) => rows ?? [])
    .filter(({ transactionDate }) => !!transactionDate);

  const amounts = transactions
    .map(({ transactionDate, investmentAmount }) => ({
      // Calendar date, not an instant — see the note in useAmountOfDealsOverTime.
      date: plainDateToZonedDateTime(transactionDate),
      value: investmentAmount ?? 0,
    }))
    .filter(({ date: d }) => isValidDate(d));

  // Axis follows the same rule as the rounds chart (investmentAmount !== 0) so the two cards
  // agree on a company's history span; amounts predating the axis fold into the first bucket.
  const investmentDates = transactions
    .filter(({ investmentAmount }) => investmentAmount !== 0)
    .map(({ transactionDate }) => plainDateToZonedDateTime(transactionDate))
    .filter(isValidDate);

  return cumulativeQuarterSeries(
    amounts,
    QuartersBuilder.axisQuartersSince(earliestOf(investmentDates), date),
    'Investment Amount'
  );
}
